// Mercapoli - Footer Global
import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="Mercapoli" className="w-10 h-10" />
              <span className="font-heading text-xl font-bold">Mercapoli</span>
            </div>
            <p className="text-muted-foreground text-sm">
              Conectamos comercios, repartidores y clientes en una plataforma moderna de delivery.
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4">Empresa</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/sobre-nosotros" className="hover:text-foreground transition-colors">Sobre nosotros</Link></li>
              <li><Link to="/trabaja-con-nosotros" className="hover:text-foreground transition-colors">Trabaja con nosotros</Link></li>
              <li><Link to="/blog" className="hover:text-foreground transition-colors">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/terminos-y-condiciones" className="hover:text-foreground transition-colors">Términos y condiciones</Link></li>
              <li><Link to="/politica-de-privacidad" className="hover:text-foreground transition-colors">Política de privacidad</Link></li>
              <li><Link to="/politica-de-cookies" className="hover:text-foreground transition-colors">Cookies</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">Contacto</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="mailto:soporte@mercapoli.com" className="hover:text-foreground transition-colors">soporte@mercapoli.com</a></li>
              <li><a href="tel:+50241282828" className="hover:text-foreground transition-colors">+502 4128-2828</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          © 2026 Mercapoli. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
